module.exports = __webpack_public_path__ + "img/34.742df876.gif";